import { useUser } from "@/providers/user";
import { UserGroups, UserProfile, UserType } from "@/types/user";
import { LockClosedIcon } from "@radix-ui/react-icons";

export default function Protected({
    children,
    groups,
    profiles,
    excludedProfiles,
    allowed,
}: {
    children: JSX.Element;
    groups?: UserGroups[];
    profiles?: UserProfile[];
    excludedProfiles?: UserProfile[];
    /** A right the server computed for the user (e.g. `user.can_open_dialer`), checked instead of groups and profiles. */
    allowed?: (user: UserType) => boolean;
}) {
    const { user, has_any_group, has_any_profile } = useUser();

    if (user && excludedProfiles?.includes(user.profile)) {
        return (
            <div className="p-5">
                <div className="border rounded p-5 max-w-[350px] mx-auto text-center">
                    <div className="flex items-center justify-center mb-2">
                        <LockClosedIcon className="w-5 h-5 mr-2 text-red-600" />
                        <h1 className="font-bold text-xl">Accès refusé</h1>
                    </div>
                    <h2 className="text-sm">Vous n'avez pas le droit d'accéder à cette page</h2>
                </div>
            </div>
        );
    }

    if (user && (groups?.length || profiles?.length || allowed)) {
        const allowedByGroup = !!groups?.length && has_any_group(groups);
        const allowedByProfile = !!profiles?.length && has_any_profile(profiles);
        const allowedByRight = !!allowed && allowed(user);
        if (!allowedByGroup && !allowedByProfile && !allowedByRight) {
            return (
                <div className="p-5">
                    <div className="border rounded p-5 max-w-[350px] mx-auto text-center">
                        <div className="flex items-center justify-center mb-2">
                            <LockClosedIcon className="w-5 h-5 mr-2 text-red-600" />
                            <h1 className="font-bold text-xl">Accès refusé</h1>
                        </div>
                        <h2 className="text-sm">Vous n'avez pas le droit d'accéder à cette page</h2>
                    </div>
                </div>
            );
        }
    }

    return <>{children}</>;
}
